export default __webpack_public_path__ + "static/media/Pistol_9.64c9c520.png";